import { render, staticRenderFns } from "./AddOnSale.vue?vue&type=template&id=a3923558&scoped=true"
import script from "./AddOnSale.vue?vue&type=script&lang=js"
export * from "./AddOnSale.vue?vue&type=script&lang=js"
import style0 from "./AddOnSale.vue?vue&type=style&index=0&id=a3923558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3923558",
  null
  
)

export default component.exports